/**
 * Basic HTTP client
 */
import ky from 'ky'
import authHook from './hooks/auth-hook'

const httpClient = ky.create({
  prefixUrl: import.meta.env.PUBLIC_BASE_API_URL,
  hooks: {
    beforeRequest: [authHook],
  },
})

export default httpClient
